import { ServiceTypeConstants } from '../constants/serviceType.constants';

export function serviceTypes(state = {}, action) {
  switch (action.type) {
    case ServiceTypeConstants.GET_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        service_types:action.data
      };
    case ServiceTypeConstants.GET_SERVICE_TYPE_FAILURE:
      return {
          ...state,
          service_types:''
      };
    case ServiceTypeConstants.GET_SERVICE_TYPE_REQUEST:
      return {};
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/serviceType.reducer.js